import { keyframes } from "@emotion/react";
import { Box, CardMedia, Typography } from "@mui/material";
import BWAutoworld from "assets/InTheNew/BWAutoworld.svg";
import EconomicTimes from "assets/InTheNew/EconomicTimes.svg";
import OutlookBusiness from "assets/InTheNew/outlookBusiness.svg";
import Silicon from "assets/InTheNew/Silicon.png";
import TimesOfIndia from "assets/InTheNew/TimesOfIndia.svg";
import YourStory from "assets/InTheNew/YourStory.svg";
import React from "react";

const news = [
  { id: 1, name: "YourStory", src: YourStory },
  { id: 2, name: "TimesOfIndia", src: TimesOfIndia },
  { id: 3, name: "EconomicTimes", src: EconomicTimes },
  { id: 4, name: "BWAutoworld", src: BWAutoworld },
  { id: 5, name: "OutlookBusiness", src: OutlookBusiness },
  { id: 6, name: "Silicon", src: Silicon },
];
const duplicatedImages = [...news, ...news];
// Define the keyframes for the scrolling animation
const loopAnimation = keyframes`
  0% {
    transform: translateX(0);
  }
  100% {
    transform: translateX(-100%);
  }
`;

export default function TheNews() {
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        gap: "12px",
        width: "100%",
      }}
    >
      <Typography
        sx={{
          transform: "rotate(0.103deg)",
          alignSelf: "stretch",
          color: "#020A0D",
          textAlign: "center",
          fontFamily: "Inter",
          fontSize: { xs: "23px", sm: "28px", md: "40px" },
          fontWeight: 600,
          lineHeight: 1.4,
        }}
      >
        In the News
      </Typography>

      <Box
        sx={{
          display: "flex",
          justifyContent: "flex-start",
          height: { xs: "97.28px", sm: "", md: "156px" },
          alignItems: "center",
          flexShrink: 0,
          animation: `${loopAnimation} 8s linear infinite`,
          mixBlendMode: "luminosity",
          willChange: "transform",
          width: "fit-content",
          gap: "24px",
          border: "1px solid red",
          boxSizing: "border-box",
        }}
      >
        {duplicatedImages.map((item) => (
          <CardMedia
            key={item.id}
            component="img"
            image={item.src}
            alt={item.name}
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              width: "100%",
              height: "100%",
              objectFit: "cover",
              // border: "1px solid red",
            }}
          />
        ))}
      </Box>
    </Box>
  );
}
